import './styles/menu.css'

//Components
import { AiOutlineControl } from "react-icons/ai"
import { GoPeople } from "react-icons/go"
import { PiChalkboardTeacher } from "react-icons/pi"
import { LiaLayerGroupSolid } from "react-icons/lia"

//Extras
import { fontType } from '../assets/extras'
import { useNavigate } from 'react-router-dom'

const Menu = ({ reference, academia }) => {

    const navigate = useNavigate()

    return (
        <div className="mainMenu">
            <div className='menu' id='menu' style={{
                fontFamily: fontType.title
            }}>
                <div className='item' onClick={() => {
                    navigate("/controlpanel", {
                        state: {
                            ref: reference,
                            academia: academia
                        }
                    })
                }}>
                    <AiOutlineControl size={30} />
                    <h3>ADMINISTRACION</h3>
                </div>

                <div className='item' onClick={() => {
                    navigate("/players", {
                        state: {
                            ref: reference,
                            academia: academia
                        }
                    })
                }}>
                    <GoPeople size={30} />
                    <h3>JUGADORES</h3>
                </div>

                <div className='item' onClick={() => {
                    navigate("/teachers", {
                        state: {
                            ref: reference,
                            academia: academia
                        }
                    })
                }}>
                    <PiChalkboardTeacher size={30} />
                    <h3>PROFESORES</h3>
                </div>

                <div className='item' onClick={() => {
                    navigate("/classes", {
                        state: {
                            ref: reference,
                            academia: academia
                        }
                    })
                }}>
                    <LiaLayerGroupSolid size={30} />
                    <h3>CLASES</h3>
                </div>
            </div>
        </div>
    )
}

export default Menu